// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import './css/reset.css'
import './assets/fonts/font.css'
import './utils/fnResize'
import MetaInfo from 'vue-meta-info'
// 使用aos动画
import AOS from 'aos/dist/aos.js'
import 'aos/dist/aos.css'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'

Vue.use(MetaInfo)
Vue.use(ElementUI)
Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  mounted () {
    AOS.init({
      offset: 200,
      duration: 600,
      easing: 'ease-in-sine',
      delay: 100
    })
    /*  document.dispatchEvent(new Event('render-event')) */
  },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js